export default {
  create: 'Créer',
}
